export default "__VITE_ASSET__D1U5Bn9X__"